export const isGoogleBot =
  'userAgent' in navigator
    ? /(?:APIs-Google|Mediapartners-Google|AdsBot-Google-Mobile|AdsBot-Google|Googlebot-Image|Googlebot-News|Googlebot-Video|Googlebot|googleweblight|Google-Travel-Flights)/i.test(
        navigator.userAgent,
      )
    : false;
